<div class="atn-ds-date-range-overlay-content-form">
  <!-- Start Date Input -->
  <atn-ds-text
    label="Start"
    [value]="formattedDateStartSg()"
    (change)="startDateChangeHandler($event)"
    placeholder="BOT"
  />

  <!-- End Date Input -->
  <atn-ds-text
    label="End"
    [value]="formattedDateEndSg()"
    (change)="endDateChangeHandler($event)"
    placeholder="EOT"
  />

  <!-- Duration Input -->
  <atn-ds-date-range-duration-input />
</div>
